export enum WepodGenderTypeEnum {
  ZAN = 0,
  MARD = 1,
}
